<!-- Leave the iframe as outer-most element  -->
<iframe
	#innerAppIframe
	*ngIf="iframeSrc$ | async as iframeSrc; else loading" [src]="iframeSrc"
	allow="clipboard-read; clipboard-write"
>
</iframe>
<ng-template #loading>
	<div class="loading-container">
		<div class="inner-loading-container">
			<p>Loading...</p>
		</div>
	</div>
</ng-template>
